import React from 'react';
import { Empty } from 'components';
import { Paper } from '@material-ui/core';
import ImagePlaceholder from 'assets/img/placeholder/empty-state.svg';
import classes from './EmptyState.module.scss';

const EmptyState = () => {
  return (
    <Paper className={classes.emptyState}>
      <Empty image={ImagePlaceholder} title='You don’t have any purchase order' />
    </Paper>
  );
};

export default EmptyState;
